<script setup>
import { computed } from 'vue'
import SelectButton from 'primevue/selectbutton'
import OverviewKpiCard from './OverviewKpiCard.vue'
import { useOverviewStore } from '../../../../../state/overviewStore.js'
import { trans } from 'laravel-vue-i18n'

const store = useOverviewStore()
const kpi   = computed(() => store.currentKpi)

const cards = computed(() => [
    { id: 'pocet',    label: trans('dashboard.kpi_reservations') },
    { id: 'cekajici', label: trans('dashboard.kpi_pending') },
    { id: 'trzby',    label: trans('dashboard.kpi_revenue') },
    { id: 'klienti',  label: trans('dashboard.kpi_new_clients') },
    { id: 'konverze', label: trans('dashboard.kpi_conversion') },
])

const periods = computed(() => [
    { key: 'dnes',  label: trans('dashboard.period_today') },
    { key: 'tyden', label: trans('dashboard.period_week') },
    { key: 'mesic', label: trans('dashboard.period_month') },
])
</script>

<template>
    <div class="mb-4 -mt-8">
        <div class="flex justify-end mb-3 gap-4">
            <slot/>
            <SelectButton
                v-model="store.period"
                :options="periods"
                option-label="label"
                option-value="key"
                :allow-empty="false"
            />
        </div>

        <!-- KPI grid -->
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3.5">
            <OverviewKpiCard
                v-for="card in cards"
                :key="card.id"
                :label="card.label"
                :kpi="kpi?.[card.id] ?? { value: 0, delta: 0, trend: [] }"
            >
                <template #icon>
                    <!-- calendar -->
                    <svg v-if="card.id === 'pocet'" class="w-[17px] h-[17px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="4" width="18" height="17" rx="2"/><path d="M3 9h18M8 2v4M16 2v4"/></svg>
                    <!-- clock -->
                    <svg v-else-if="card.id === 'cekajici'" class="w-[17px] h-[17px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>
                    <!-- wallet -->
                    <svg v-else-if="card.id === 'trzby'" class="w-[17px] h-[17px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="6" width="18" height="13" rx="2.5"/><path d="M3 10h18M16 14h.01"/></svg>
                    <!-- user -->
                    <svg v-else-if="card.id === 'klienti'" class="w-[17px] h-[17px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="8" r="3.3"/><path d="M5.5 20c.8-3.2 3.4-4.8 6.5-4.8s5.7 1.6 6.5 4.8"/></svg>
                    <!-- funnel -->
                    <svg v-else-if="card.id === 'konverze'" class="w-[17px] h-[17px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 5h18l-7 8v6l-4-2v-4z"/></svg>
                </template>
            </OverviewKpiCard>
        </div>
    </div>
</template>
